module.exports = __webpack_public_path__ + "static/media/JP_RB_EYELASHES02.46e169ab.jpg";